export const BpProjectPermissions: string[] = [
  "plans",
  "bimModels",
  "bimSections",
  "missions",
  "structure",
];
